import { render, staticRenderFns } from "./SearchTipoDiagnosticoComponent.vue?vue&type=template&id=2bc4fa02&"
import script from "./SearchTipoDiagnosticoComponent.vue?vue&type=script&lang=js&"
export * from "./SearchTipoDiagnosticoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports